
import React, { useEffect, useRef, useState } from 'react';
import sriimg from "../../../Assets/image 17843.png";
import familyImg from "../../../Assets/Isolation_Mode.png";
import * as Icon from "react-bootstrap-icons";
import groupImg from "../../../Assets/en_badge_web_generic.png";
import SakalLogo from "../../../Assets/sakal-digital-2 1.png"
import OwlCarousel from 'react-owl-carousel';

import eventBG from "../../../Assets/eventBg.svg";
import eventIMG from "../../../Assets/eventImg.svg"
import Location from "../../../Assets/Location.svg"
import Calender from "../../../Assets/Calendar.svg"
import "./LandingPage/Landing.css"
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { Pillars } from './components/Pillars';

import { FeaturesCarousel } from './components/Features';

const LandingPage = () => {

    const navigate = useNavigate()
    const gradientStyle = {
        background: 'linear-gradient(to top, #FFD2C4, #FFEEE9, #FFFCFB)'
    }

    return <div style={{ flex: 1, ...gradientStyle, paddingBottom: 0 }}>

        {/* Section 1 - Header */}
        <section id="header">
            <div>
                <img id='sfg-logo-text' src={sriimg} alt='img' />
            </div>
            <div>
                <img id='sfg-logo-image' src={familyImg} alt='img' />
            </div>
            <div>
                <button onClick={() => {
                      navigate("/mobilenumber");
                    }} id='download'>Login</button>
            </div>

        </section>

        {/* Section 2 - Event */}
        <section id='event'>
            <div className="event-container d-flex justify-content-center align-items-center" style={{ background: `url(${eventBG}) center/cover no-repeat` }} >
                <div className='event-image' >
                    <img src={eventIMG} />
                </div>
                <div className='event-text'>
                    <h2 style={{
                        fontWeight: '400', color: '#2B2B2B', fontFamily: "Devanagari Sangam MN"
                    }}>
                        सामाजिक, आध्यात्मिक, शारीरिक आणि आर्थिक प्रगती करण्याचा
                    </h2>
                    <h1 style={{ fontSize: '40px', fontWeight: '700', color: '#2B2B2B', fontFamily: "Devanagari Sangam MN", textAlign: 'center' }}>संकल्प ते सिद्धी सोहळा !</h1>
                    <div className='d-flex justify-content-center align-items-center'>
                        <p style={{ fontSize: '12px', fontWeight: '400' }}><img width={16} src={Calender} /><span> २६ मार्च २०२४ - २७ मार्च २०२४</span></p>
                        <p style={{ fontSize: '12px', fontWeight: '400', marginLeft: '20px' }}><img width={16} src={Location} /><span> सिडको एक्सहिबिशन सेंटर, वाशी, नवी मुंबई</span></p>
                    </div>

                    <p style={{ fontSize: '35px', fontWeight: '700', color: '#882425', fontFamily: "Devanagari Sangam MN", textAlign: 'center' }}>प्रवेश विनामूल्य</p>

                    <div className='mt-5' style={{ display: 'flex', justifyContent: 'center' }}>
                        <button className="downloadBtn" onClick={() => navigate("/event-page")}>नोंदणी करा<Icon.ArrowRight className='ms-2' /></button>
                    </div>
                </div>
            </div>
        </section>

        {/* Section 3 Hero */}
        <section id='hero'>
            <div className='mt-5' style={{ textAlign: 'center' }}>
                <h1 className='m-0 p-0'>Holistic Lifestyle<br />Guidance Program</h1>
            </div>

            <div className='section-1-desc my-5'>
                <h6 className='m-0 p-0'>The Journey of Success & Self Happiness.</h6>
                <p className='mt-5 px-md-5' style={{ textAlign: 'justify' }}>Often, success is co-related with happiness. Happiness is subjective and the pursuit of happiness is a complex landscape of self expectations, hard work, and material desires. However, as we journey through life, we come to realize that happiness is not a destination to reach, rather it is a way of life.</p>
            </div>

            <div className="d-flex justify-content-center mt-3 my-md-3">
                <Row className='justify-content-center'>
                    <Col xs={8} md={5}>
                        <a href='https://play.google.com/store/apps/details?id=com.srifamilyguide.app'>
                            <img src={groupImg} className='w-100' />
                        </a>
                    </Col>
                </Row>
            </div>
        </section>

        {/* Section 4 - Family Picture  */}
        <section id='fam-pic'>
            <div className='family-image'>
                <p className='family-text'>Often, success is co-related with happiness. Happiness is subjective and the pursuit of happiness is a complex landscape of self expectations, hard work, and material desires. However, as we journey through life, we come to realize that happiness is not a destination to reach, rather it is a way of life.</p>
            </div>
        </section>

        {/* Section 5 -Pillars */}
        <section id='pillars'>
            <Pillars />
        </section>

        {/* Section 6 Sakal Data */}
        <section id="sakal">
            <div style={{
                border: "1px solid #A7A7A7",
                padding: "20px 40px",
                borderRadius: "10px",
                margin: "20px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "space-between",
                // ...gradientStyle
            }}>
                <Row>
                    <Col md={5}>
                        <img src={SakalLogo} className='img-fluid' />
                    </Col>
                    <Col md={7}>
                        <p style={{ fontWeight: '600' }}>Esteemed as India’s distinguished media company, commitment at Sakal Media Group,
                            extends beyond business success. With a steadfast belief in the power of business for good,
                            Sakal Media integrates social responsibility and community wellness into the fabric of everything it undertakes.
                        </p>
                        <p style={{ fontWeight: '400' }}>From our diverse portfolio, we actively seek opportunities to uplift and empower communities.</p>
                        <p style={{ fontWeight: '400' }}>Whether it is the ‘Family Doctor’ pustika, Arogya Sakal Expo, or Swasthyam event,
                            we address pressing lifestyle issues and try to impact lives in a positive way.
                            As an upswing of all these activities, we now come ahead with a holistic lifestyle guidance program –‘Sri Family Guide’.</p>
                    </Col>
                </Row>
                <div>

                </div>
                <div style={{ maxWidth: "calc(60% - 15px)" }}>


                </div>
            </div>

        </section>

        <section id="material">
            <FeaturesCarousel />
        </section>

        <footer>
            {/* contact section */}
            <div className='mb-5 px-5'>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "25%" }}>
                    <img src={familyImg} style={{ width: '200px' }} />
                    <img className='mt-2' src={sriimg} alt='img' style={{ width: '150px' }} />
                </div>
                <div className="mt-4">
                    <p style={{ fontWeight: 500, fontSize: "25px", textAlign: "center", lineHeight: "30px", fontFamily: '"Exo 2", sans-serif' }}>To Join Sri Family Guide Contact Us Here</p>
                </div>

                <div className='d-flex justify-content-between align-items-center flex-wrap px-3'>
                    <div style={{  width: '150px' }}>
                        <p >
                            <span style={{ fontSize: '14px', color: '#1E1E1E', fontWeight: '400' }}>Call to Know More:</span>
                            <p className='m-0 p-0' ><a href="tel:+918956344471" style={{ textDecoration: 'none', color: '#2B2B2B', fontSize: '12px', fontWeight: '700' }}>+91 8956344471</a></p>
                        </p>
                    </div>

                    <div style={{ }}>
                        <p >
                            <span style={{ fontSize: '14px', color: '#1E1E1E', fontWeight: '400' }}>Simances Learning LLP:</span>
                            <p className='m-0 p-0' style={{ color: '#2B2B2B', fontSize: '12px', fontWeight: '700' }}>82/1A & 83/1A, Sakal Nagar, Gate no. 1, Baner Road, Anudh, Pune, Maharashtra(411007)</p>
                        </p>
                    </div>

                    <div>
                        <p>
                            <span style={{ fontSize: '14px', color: '#1E1E1E', fontWeight: '400' }}>Write Us: </span>
                            <p className='m-0 p-0' ><a href="mailto:info@srifamilyguide.com" style={{ textDecoration: 'none', color: '#2B2B2B', fontSize: '12px', fontWeight: '700' }}>info@srifamilyguide.com</a></p>
                        </p>
                    </div>
                </div>
            </div>

            {/* footer section */}
            <div style={{ display: "flex", backgroundColor: "#000000", justifyContent: "space-between", alignItems: "center", padding: "15px 10px" }}>
                <p className="p-0 m-0" style={{ fontWeight: 400, fontSize: "12px", fontFamily: '"Exo 2", sans-serif', color: '#fff' }}>All Rights Reserved</p>
                <p className="p-0 m-0" style={{ fontWeight: 400, fontSize: "14px", fontFamily: '"Exo 2", sans-serif', color: '#fff' }} >&copy; Copyright Sakal Media Group &reg;</p>
            </div>
        </footer>

    </div>
}

export default LandingPage;
